import decode from 'jwt-decode';

import WSocket from './WSocket';
import moment from 'moment-timezone';
import 'moment/locale/ru';

// import * as axios from 'axios';
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

export default class AuthService {

    // Initializing important variables
    constructor(domain) {
        this.ws = new WSocket({ auth: this });
        var port = (process.env.REACT_APP_PORT) ? ":" + process.env.REACT_APP_PORT : "";
        var portws = (process.env.REACT_APP_PORTWS) ? ":" + process.env.REACT_APP_PORTWS : "";
        this.Hostname = window.location.hostname + port || "localhost:3000"
        this.Hostnamews = window.location.hostname + portws || "localhost:8480"
        this.schemws = process.env.REACT_APP_SCHEMWS || "ws"
        this.schemhttp = process.env.REACT_APP_SCHEMHTTP || "http"
        this.domain = domain || this.schemhttp + '://' + this.Hostname // API server domain
        this.fetch = this.fetch.bind(this) // React binding stuff
        this.login = this.login.bind(this)
        this.signup = this.signup.bind(this)
        this.getProfile = this.getProfile.bind(this)
        this._checkStatus = this._checkStatus.bind(this)
        this.PerformanceStart = this.PerformanceStart.bind(this)
        this.getPerformance = this.getPerformance.bind(this)
        this.getCookies = this.getCookies.bind(this)
        this.getCookie = this.getCookie.bind(this)
        this.performance = new Map()
    }
    getCookies() {
        var result = {}
        var cookies = document.cookie.split("; ");
        for (var i = 0; i < cookies.length; i++) {
            var spl = cookies[i].split("=");
            result[spl[0]] = spl[1];
        }
        return result;
    }
    getCookie(name) {
        var result = this.getCookies()
        return result[name];
    }
    getPerformance() {
        return this.performance;
    }
    PerformanceStart(path) {
        var start = performance.now();
        var endCallback = () => {
            var end = performance.now();
            if (this.performance.has(path)) {
                var prev = this.performance.get(path);
                this.performance.set(path, {
                    last: moment(new Date()).format(),
                    delta: end - start,
                    avg: Math.abs((end - start) + prev.avg) / 2,
                });
            } else {
                this.performance.set(path, {
                    last: moment(new Date()).format(),
                    delta: end - start,
                    avg: end - start,
                });
            }
        };
        return endCallback
    }
    setHandle(options) {
        this.ShowMessage = options.ShowMessage
    }
    openSocket(path, name, onmessage, onopen, onclose, onerror) {
        if(this.ws.state.ws[name]) {
			this.ws.close(name, false);
		}
		this.ws.open(this.schemws+"://"+this.Hostnamews+path, name, 
        //onmessage
        function (e) {
			try {
                var message = JSON.parse(e.data);
                onmessage(message.type, message.payload)
			} catch (ex) { }
		},
        //onopen
        onopen,
        //onclose
        onclose,
        //onerror
        onerror
        );
    }
    closeSocket(name) {
        this.ws.close(name);
    }

    login(email, password) {
        localStorage.removeItem('app_iface');

        // Get a token from api server using the fetch api
        return this.fetch(`/api/login`, {
            method: 'POST',
            body: JSON.stringify({
                email,
                password
            })
        }).then(res => {
            if (res && res.user && res.user.token) {
                // this.setToken(res.user.token); // Setting the token in localStorage
                localStorage.setItem('iam', res.user.ID);
                if (res.user.roleUser && res.user.roleUser.length) {
                    for (var i = 0; i < res.user.roleUser.length; i++) {
                        res.user.roleUser.sort(function (a, b) {
                            return a.role.priority - b.role.priority;
                        });
                        if (res.user.roleUser[i].roleID === 2) {
                            localStorage.setItem("app_iface", "admin");
                        } else if (res.user.roleUser[i].roleID === 3) {
                            localStorage.setItem("app_iface", "judge");
                        } else if (res.user.roleUser[i].roleID === 4) {
                            // localStorage.setItem("app_iface", "dancer");
                            localStorage.setItem("app_iface", "judge");
                        } else {
                            localStorage.removeItem('app_iface');
                        }
                    }
                }
            }
            return Promise.resolve(res);
        })
    }

    signup(data) {
        data.genderID = +data.genderID;
        data.regionID = +data.regionID;
        data.cityID = +data.cityID;
        data.tipTelefonaID = +data.tipTelefonaID;
        // Get a token from api server using the fetch api
        return this.fetch(`/api/signup`, {
            method: 'POST',
            body: JSON.stringify(data)
        }).then(res => {
            if (res && res.user && res.user.token) {
                // this.setToken(res.user.token) // Setting the token in localStorage
                localStorage.setItem('iam', res.user.ID);
            }
            return Promise.resolve(res);
        })
    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage
        return !!token && !this.isTokenExpired(token) // handwaiving here
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    // setToken(idToken) {
    //     // Saves user token to localStorage
    //     localStorage.setItem('id_token', idToken)
    // }

    getToken() {
        // Retrieves the user token from localStorage
        return this.getCookie("token")
        // return localStorage.getItem('id_token')
    }

    logout(cb) {
        // Clear user token and profile data from localStorage
        // localStorage.removeItem('id_token');

        this.fetch(`/api/logout`).then(res => {
            if (res) {
                if (cb) {
                    cb();
                }
            }
        })
    }

    getProfile() {
        // Using jwt-decode npm package to decode the token
        return decode(this.getToken());
    }

    fetchFile(url, options) {
        const headers = {
            // 'X-Requested-With': 'XMLHttpRequest'
        }
        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        var end = this.PerformanceStart(url);
        return fetch(this.domain + url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then((res) => {
                if (end) {
                    end();
                }
                res.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = decodeURI(res.headers.get("x-filename"));
                    a.click();
                });
            })
    }

    fetch(url, options) {
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        var end = this.PerformanceStart(url);
        return fetch(this.domain + url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => {
                if (end) {
                    end();
                }
                return response.json();
            })
            .then(res => {
                if (res && !res.status) {
                    if (this.ShowMessage) {
                        this.ShowMessage(res.message, "danger")
                    }
                }
                return Promise.resolve(res);
            })
    }

    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else if (response.status == 401) {
            console.error(response.status, "Не авторизован", response.url);
            history.replace('/login');
            history.go(0);
            return response;
        } else if (response.status === 403) {
            console.error(response.status, "Доступ запрещен", response.url);
            return response;
        } else {
            // if(this.ShowMessage) {
            //     this.ShowMessage(response.statusText, "danger")
            // }
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}